import gsap from "gsap/all";

/**
 * |====================================================================
 * | Animate From source center to destination Element Center
 * |====================================================================
 * | This is animation that will create a clone of element node and
 * | create a transition from that node to a sourceSelectorId
 * | and will push these element into body attribute of your document.
 * | this method has one dependency that is GSAP ( url https://greensock.com/)
 * |
 */

/**
 *
 * @param {object} item
 * @param {?string} destinationId
 */
function animateItemToCart(
  item,
  durationSecond = 1.5,
  destinationId = "_cart-id"
) {
  var sourceId;
  if (typeof item === "object") {
    if (!(item && item.Id)) {
      console.error("item [object] is required", item);
      return;
    }
    sourceId = `_cart-item-${item.Id}`;
  } else if (!isNaN(Number(item))) {
    sourceId = `_cart-item-${item}`;
  } else {
    console.error("item must be object with Number Id or Number Id");
    return;
  }
  animateTo(sourceId, durationSecond, destinationId);
}
/**
 * duration Second will be the total time duration for animation.
 * 80% duration will use for animate item to cart and rest 20% will be use for animate
 * destination icon/button.
 * @param {string} sourceSelectorId
 * @param {number} durationSecond
 * @param {string} destinationSelectorId
 */
function animateTo(
  sourceSelectorId = null,
  durationSecond,
  destinationSelectorId
) {
  if (!sourceSelectorId) {
    console.error("Source Id is required");
    return;
  }
  if (!destinationSelectorId) {
    console.error("Destination Id is required");
    return;
  }
  let el = document.getElementById(sourceSelectorId);
  let cart = document.getElementById(destinationSelectorId);
  if (!cart) {
    console.error("no element found with Id " + destinationSelectorId);
    return;
  }
  if (!el) {
    console.error("no element found with Id " + sourceSelectorId);
    return;
  }
  let elementBoundary = el.getBoundingClientRect();
  let cartBoundary = cart.getBoundingClientRect();
  let newNode = el.cloneNode(true);
  let idName = "_animated" + sourceSelectorId;
  newNode.id = idName;
  newNode.style.position = "absolute";
  newNode.style.top = elementBoundary.top + "px";
  newNode.style.left = elementBoundary.left + "px";
  newNode.style.width = elementBoundary.width + "px";
  newNode.style.height = elementBoundary.height + "px";
  let animatedParentDiv = parentElement("_animation-parent");
  animatedParentDiv.appendChild(newNode);
  let translateY =
    cartBoundary.top +
    cartBoundary.height / 2 -
    (elementBoundary.top + elementBoundary.height / 2);
  let translateX =
    cartBoundary.left +
    cartBoundary.width / 2 -
    (elementBoundary.left + elementBoundary.width / 2);
  animatedParentDiv.style.zIndex = "10";
  animateItemTo(
    sourceSelectorId,
    { x: translateX, y: translateY },
    durationSecond,
    cart,
    animatedParentDiv
  );
}
function animateItemTo(
  sourceSelectorId,
  translateValues,
  durationSecond,
  cart,
  animatedParentDiv
) {
  gsap.from("#_animated" + sourceSelectorId, {
    opacity: 0,
    scale: 1,
    duration: 1,
  });
  gsap.to("#_animated" + sourceSelectorId, {
    ...translateValues,
    scale: 0.1,
    duration: durationSecond * 0.7,
    ease: "ease",
    onComplete: () => {
      document.getElementById("_animated" + sourceSelectorId).remove();
      animateCartIcon(cart, durationSecond * 0.3);
      if (!animatedParentDiv.hasChildNodes()) {
        animatedParentDiv.style.zIndex = "auto";
      }
    },
  });
}
function animateCartIcon(cart, durationSecond) {
  gsap.to(cart, {
    scale: 1.2,
    ease: "ease",
    duration: durationSecond * 0.5,
    onComplete: () => {
      gsap.to(cart, {
        scale: 1,
        duration: durationSecond * 0.5,
        ease: "ease",
      });
    },
  });
}
function parentElement(idName = "#_animation-parent") {
  let animatedParentDiv = undefined;
  animatedParentDiv = document.querySelectorAll("#" + idName);
  if (!animatedParentDiv.length) {
    animatedParentDiv = document.createElement("div");
    animatedParentDiv.id = "_animation-parent";
    animatedParentDiv.style.position = "fixed";
    animatedParentDiv.style.top = "0";
    animatedParentDiv.style.left = "0";
    document.body.append(animatedParentDiv);
    animatedParentDiv = document.querySelectorAll("#" + idName);
  }
  return animatedParentDiv[0];
}
export { animateTo, animateItemToCart as default };
